import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';

import {
  useChangeFriendsGroupNameMutation,
  useCreateUserFriendsGroupMutation,
} from '@/api/queries/group';
import { H2 } from '@/components/Typography/Typography';

interface prop {
  name: string;
  active: boolean;
  setOpen: (e: boolean) => void;
}

const Window: React.FC<prop> = ({ name, active, setOpen }) => {
  const [createFriendsGroup] = useCreateUserFriendsGroupMutation();
  const [changeFriendsGroupName] = useChangeFriendsGroupNameMutation();
  const [nameGroup, setNameGroup] = useState('');
  const [errorMessage, setErrorMessage] = useState(false);

  useEffect(() => setNameGroup(name), [name]);

  const handleCreate = (): void => {
    const trimmedNameGroup = nameGroup.trim();

    if (!trimmedNameGroup) {
      setErrorMessage(true);

      return;
    }
    setOpen(false);

    if (name) {
      changeFriendsGroupName({ groupName: trimmedNameGroup });
    } else {
      createFriendsGroup({ groupName: trimmedNameGroup });
    }
  };

  return (
    <div className={`modalUpdateBackground ${active ? 'open' : ''}`}>
      <CSSTransition
        in={active}
        timeout={300}
        classNames="newGroupWindow-modal"
        unmountOnExit
      >
        <div className="newGroup">
          <div className="newGroupWindow">
            <H2>Name your group</H2>
            <input
              type="text"
              name="group"
              value={nameGroup}
              onChange={(e) => {
                setNameGroup(e.target.value);
                setErrorMessage(false);
              }}
              required
            />
            {errorMessage && (
              <span className="error-Message">Name cannot be empty</span>
            )}
            <div>
              <button
                type="button"
                className="btn btn-dark"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <button type="button" className="btn" onClick={handleCreate}>
                {name ? 'Ok' : 'Create'}
              </button>
            </div>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default Window;
